import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { ProductActivationWrapper } from "../../components/ProductActivationWrapper/ProductActivationWrapper";
import { RouteEnroll } from "./routes/RouteEnroll";
import {
  PATH_BENEFITS_ENROLL,
  PATH_BENEFITS_INSURANCE,
  PATH_BENEFITS_INSURANCE_ENROLL,
  PATH_BENEFITS_PERKS
} from "./paths";
import { RouteBenefitsInsuranceIndex } from "./routes/RouteBenefitsInsurance/RouteBenefitsInsuranceIndex";
import { RouteBenefitsPremiumPerksIndex } from "./routes/RouteMyBenefits/RouteBenefitsPremiumPerksIndex";
import { RouteEnrollInsurance } from "./routes/RouteEnrollInsurance";

export const BenefitsRoutes: React.FC = () => {
  return (
    <ProductActivationWrapper>
      <Switch>
        <Route
          path={PATH_BENEFITS_INSURANCE}
          component={RouteBenefitsInsuranceIndex}
        />

        <Route
          path={PATH_BENEFITS_PERKS}
          component={RouteBenefitsPremiumPerksIndex}
        />

        <Route path={PATH_BENEFITS_ENROLL} component={RouteEnroll} />

        <Route
          component={RouteEnrollInsurance}
          path={PATH_BENEFITS_INSURANCE_ENROLL}
        />

        <Redirect from="*" to={PATH_BENEFITS_PERKS} />
      </Switch>
    </ProductActivationWrapper>
  );
};
export { PATH_BENEFITS_ENROLL } from "./paths";
